module.exports = __webpack_public_path__ + "static/img/improvement_1.316a667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/improvement_1.png
// module id = pAI6
// module chunks = 1